import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const ChainReactionAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const dots = 30;
  const delay = progress * dots;
  for (let i = 0; i < dots; i++) {
    if (delay < i) continue;
    const ang = (i / dots) * Math.PI * 2;
    const r = getRadiusAtAngle(ang, e, e.maxRadius);
    const tLocal = (delay - i) / 8;
    const dy = 1000 * tLocal * tLocal;
    ctx.beginPath(); ctx.arc(e.pos.x + Math.cos(ang) * r, e.pos.y + Math.sin(ang) * r + dy, 8 * (1 - progress), 0, Math.PI * 2);
    ctx.fill();
  }
};

registerBlastAnimation('CHAIN_REACTION', ChainReactionAnimation);
